import { useIsFetching } from '@tanstack/react-query';

import { SteadoLoader } from './SteadoLoader';

/**
 * The design's "fetching" spinner in the top bar. Driven by TanStack Query's
 * global in-flight count, so every screen gets it without wiring anything.
 */
export function FetchIndicator() {
  const isFetching = useIsFetching() > 0;

  if (!isFetching) {
    return null;
  }

  return (
    <span role="status" className="flex items-center gap-[7px] text-xs text-muted-foreground">
      <SteadoLoader className="size-4 text-primary" />
      fetching
    </span>
  );
}
